import axios from "axios";
import { its_access } from "../../hooks/useAssets";
import fetcher, { NOT_FOUND, STATUS_CREATED, STATUS_OK } from "../../libs/fetcher";
import { IIndexParamsPmv, IIndexResponsePmv, IStoreParamsPmv, IStoreResponsePmv, initialIPmv } from "../../models/Pmv";

const { REACT_APP_PHP_SERVER } = process.env

// Método para obtener configurciones de paneles
export const indexPMV = async ({ package_id, page, pageSize }: IIndexParamsPmv): Promise<IIndexResponsePmv> => {
    const url = `/assets_its/pmv`;
    let response: IIndexResponsePmv = { data: [], totalItems: 0, error: true };

    try {
        const fetchResponse = await fetcher({
            url,
            method: 'GET',
            params: { package_id, page, pageSize }
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;

        // console.log("🚀 ~ file: pmv.ts:22 ~ indexPMV ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (Array.isArray(responseData.data)) {
                    response.data = responseData.data;
                    response.error = false;
                    response.totalItems = responseData.totalItems;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}
// Método para almacenar la configuración del panel
export const storePmv = async (data: IStoreParamsPmv): Promise<IStoreResponsePmv> => {
    const defaultResponse: IStoreResponsePmv = { status: false, data: initialIPmv, message: 'No se pudo procesar la petición' };
    try {
        const res = await fetcher({
            url: `/assets_its/pmv`,
            method: 'POST',
            data
        });
        if (!res) throw new Error('Request failed');

        const { fetch } = res;

        // console.log("🚀 ~ store ~ fetch:", fetch)

        if (typeof fetch === 'string') throw new Error('Request Unknown');

        if (fetch instanceof Object) {
            if ('status' in fetch) {

                const responseData = 'data' in fetch ? fetch.data : null;

                if (fetch.status === STATUS_CREATED && responseData) {
                    defaultResponse.data = responseData.data;
                    defaultResponse.status = fetch.status;
                } else if (fetch.status === NOT_FOUND && responseData) {
                    defaultResponse.status = fetch.status;
                    defaultResponse.message = responseData.message;
                }
            }
        }
        return defaultResponse;
    } catch (error) {
        return defaultResponse;
    }
}
// Método para enviar el mensaje directamente al panel
export const sendPostRequest = async (pmv_string: string, assetId: number) => {
    const formData = new URLSearchParams();
    formData.append("action", "update");
    formData.append("Multistring", pmv_string);

    try {
        const { xaddr } = its_access.find(item => item.id === assetId) || { xaddr: "" };
        const response = await fetch(`${xaddr}/testmsg.htm`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });
        // console.log("🚀 ~ sendPostRequest ~ response:", response)

        if (response.ok) {
            const result = await response.text();
            console.log("Respuesta del servidor:", result);
        } else {
            console.error("Error en la solicitud:", response.status, response.statusText);
        }
    } catch (error) {
        console.error("Error al enviar la solicitud:", error);
    }
};
// Método para enviar el mensaje a través de la API
// Este método se utiliza para enviar un mensaje a un panel específico a través de una API PHP
export const sendPostRequestApi = async (pmv_string: string, assetId: number) => {
    const defaultResponse = { status: 500, message: 'No se pudo procesar la petición' };
    const formData = new URLSearchParams();
    formData.append("action", "sendPostRequest");
    formData.append("Multistring", pmv_string);
    formData.append("assetId", String(assetId));

    if (REACT_APP_PHP_SERVER) {
        try {
            const response = await axios.post(REACT_APP_PHP_SERVER, formData);
            // console.log("🚀 ~ sendPostRequest ~ response:", response)

            if(response.status === 200) {
                defaultResponse.status = 200;
                defaultResponse.message = response.data.response;
            }
            return defaultResponse;
        } catch (error: any) {
            if (error.response) {
                // El servidor respondió con un código de estado fuera del rango 2xx
                console.error("Error en la solicitud:", error.response.status, error.response.data);
            } else if (error.request) {
                // La solicitud fue hecha pero no se recibió respuesta
                console.error("No se recibió respuesta del servidor:", error.request);
            } else {
                // Algo más causó un error
                console.error("Error:", error.message);
                defaultResponse.message = error.message;
            }
            return defaultResponse;
        }
    } else {
        console.error("REACT_APP_PHP_SERVER is not defined");
        return defaultResponse;
    }

};
// Resetear la configuración del panel
export const handleReset = async (assetId: number) => {
    const formData = new URLSearchParams();
    formData.append("action", "update");

    try {
        const { xaddr } = its_access.find(item => item.id === assetId) || { xaddr: "" };
        const response = await fetch(`${xaddr}/reset.htm`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });
        // console.log("🚀 ~ handleReset ~ response:", response)

        if (response.ok) {
            const result = await response.text();
            console.log("Respuesta del servidor:", result);
        } else {
            console.error("Error en la solicitud:", response.status, response.statusText);
        }
    } catch (error) {
        console.error("Error al enviar la solicitud:", error);
    }
};
// Método para resetear la configuración del panel
export const handleResetApi = async (assetId: number) => {
    const formData = new URLSearchParams();
    formData.append("action", "handleReset");
    formData.append("assetId", String(assetId));

    if (REACT_APP_PHP_SERVER) {
        try {
            const response = await axios.post(REACT_APP_PHP_SERVER, formData);
            // console.log("🚀 ~ handleResetApi ~ response:", response);

            return response.status
        } catch (error: any) {
            if (error.response) {
                // El servidor respondió con un código de estado fuera del rango 2xx
                console.error("Error en la solicitud:", error.response.status, error.response.data);
            } else if (error.request) {
                // La solicitud fue hecha pero no se recibió respuesta
                console.error("No se recibió respuesta del servidor:", error.request);
            } else {
                // Algo más causó un error
                console.error("Error:", error.message);
            }
            return error.response.status;
        }
    } else {
        console.error("REACT_APP_PHP_SERVER is not defined");
        return 0;
    }
};
// Método para enviar el brillo a un panel según su dirección IP
export const sendBrightness = async (assetId: number, brightnessType: string, brightness: number) => {
    const formData = new FormData();
    formData.append('action', 'update');
    formData.append('modebright', brightnessType); // O 'Automatic', según lo necesario
    formData.append('valbright', String(brightness)); // Cambiar al valor que desees

    try {
        const { xaddr } = its_access.find(item => item.id === assetId) || { xaddr: "" };
        const response = await fetch(`${xaddr}/brightne.htm`, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formData.toString(),
        });
        // console.log("🚀 ~ sendBrightness ~ response:", response)
        if (response.ok) {
            const result = await response.text();
            console.log("Respuesta del servidor:", result);
        } else {
            console.error("Error en la solicitud:", response.status, response.statusText);
        }
    } catch (error) {

    }
};
// 
export const getPMVApi = async (pmvId: number) => {
    const formData = new URLSearchParams();
    formData.append("action", "getPMVStatus");
    formData.append("pmvId", String(pmvId));
    try {
        if (REACT_APP_PHP_SERVER) {
            const response = await axios.post(REACT_APP_PHP_SERVER, formData);
            // console.log("🚀 ~ getPMVStatus ~ response:", response)

            return response.data;
        }
    } catch (error) {
        console.error("REACT_APP_PHP_SERVER is not defined");
        return {success: false, message: "Error al obtener el estado del panel"};
    }
}